// AI transparency page (IDD D-HP-SITE-031): the transparency duties of Art.\u00a050 of the AI Act (Regulation (EU)
// 2024/1689) as the company meets them, and the competent German authority. German is the authoritative version.
export const aiTransparencyPageIT = {
  seo: {
    title: 'Trasparenza sull’IA | pAIoneer Labs GmbH',
    description: 'Come pAIoneer Labs GmbH utilizza l’intelligenza artificiale e fornisce informazioni al riguardo: assistente IA, marcatura dei contenuti generati dall’IA, responsabilità editoriale e punto di contatto ai sensi del regolamento sull’intelligenza artificiale.',
    keywords: 'trasparenza sull’IA, regolamento sull’intelligenza artificiale, AI Act, art.\u00a050, marcatura, assistente IA, pAIoneer Labs GmbH',
    url: 'https://paioneer-labs.eu/ai-transparency',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Trasparenza sull’IA',
      url: 'https://paioneer-labs.eu/ai-transparency',
      isPartOf: {
        '@type': 'WebSite',
        name: 'pAIoneer Labs GmbH',
        url: 'https://paioneer-labs.eu'
      }
    }
  },
  hero: {
    title: 'Trasparenza sull’IA',
    subtitle: 'Come pAIoneer Labs GmbH utilizza l’intelligenza artificiale e fornisce informazioni al riguardo.'
  },
  sections: [
    {
      title: 'Quadro giuridico',
      paragraphs: [
        'Dal 2 agosto 2026 si applicano gli obblighi di trasparenza di cui all’art.\u00a050 del regolamento (UE) 2024/1689 sull’intelligenza artificiale (regolamento sull’intelligenza artificiale). In Germania, ai sensi del KI-Marktüberwachungs- und Innovationsförderungsgesetz (KI-MIG, legge tedesca sulla vigilanza del mercato dell’IA e sulla promozione dell’innovazione), la Bundesnetzagentur (Agenzia federale tedesca delle reti) è l’autorità di vigilanza del mercato e l’organismo competente per i reclami relativi al regolamento sull’intelligenza artificiale.',
        'Questa pagina descrive quali sistemi di IA utilizza pAIoneer Labs GmbH e come fornisce informazioni al riguardo. Il modo in cui vengono trattati i dati personali in questo contesto è descritto nell’informativa sulla privacy.'
      ]
    },
    {
      title: 'Assistente IA nella nostra applicazione',
      paragraphs: [
        'Nella nostra applicazione un assistente IA risponde alle tue domande. È un sistema di IA: le sue risposte vengono generate automaticamente da modelli linguistici e possono essere errate. Verifica le informazioni importanti prima di basarvi delle decisioni.',
        'L’applicazione te lo segnala prima del tuo primo inserimento e in modo permanente accanto alla chat (art.\u00a050, par.\u00a01, del regolamento sull’intelligenza artificiale). Inoltre, ogni risposta dell’assistente è contrassegnata in un formato leggibile da una macchina come generata dall’IA (art.\u00a050, par.\u00a02, del regolamento sull’intelligenza artificiale).',
        'I modelli linguistici sono forniti tramite il servizio di OpenRouter, Inc., USA.'
      ]
    },
    {
      title: 'Comunicazione diretta con sistemi di IA',
      paragraphs: [
        'Se un sistema di IA di pAIoneer Labs GmbH comunica direttamente con te, ad esempio in una chat, si rende riconoscibile come sistema di IA al più tardi al momento della prima interazione.'
      ]
    },
    {
      title: 'Contenuti di questo sito web',
      paragraphs: [
        'I testi di questo sito web vengono – anche laddove strumenti di IA ne supportano la redazione – verificati da pAIoneer Labs GmbH e pubblicati sotto la sua responsabilità editoriale (art.\u00a050, par.\u00a04, secondo comma, del regolamento sull’intelligenza artificiale).',
        'Contrassegniamo come generati o modificati artificialmente i contenuti di immagini, audio o video che sono stati generati o modificati con l’IA e che rappresentano in modo ingannevolmente realistico persone, luoghi o eventi reali (art.\u00a050, par.\u00a04, primo comma, del regolamento sull’intelligenza artificiale).'
      ]
    },
    {
      title: 'Analisi con apprendimento automatico',
      paragraphs: [
        'Con il tuo consenso analizziamo le statistiche delle visite con metodi di apprendimento automatico; i dettagli sono riportati nell’informativa sulla privacy. A tal fine non utilizziamo né il riconoscimento delle emozioni né la categorizzazione biometrica (art.\u00a050, par.\u00a03, del regolamento sull’intelligenza artificiale). La distinzione tra persone e accessi automatizzati si basa su caratteristiche tecniche del dispositivo, del browser e della connessione, non su dati biometrici.'
      ]
    },
    {
      title: 'Reclamo',
      paragraphs: [
        'Puoi presentare un reclamo per una possibile violazione del regolamento sull’intelligenza artificiale alla Bundesnetzagentur, l’autorità di vigilanza del mercato e l’organismo competente per i reclami relativi al regolamento sull’intelligenza artificiale in Germania. Le relative informazioni sono messe a disposizione dalla Bundesnetzagentur su bundesnetzagentur.de/ki.'
      ]
    }
  ],
  contact: {
    title: 'Contatto',
    description: 'Per domande sull’utilizzo dell’intelligenza artificiale puoi contattarci via e-mail.',
    email: 'info@paioneer.eu'
  },
  lastUpdated: 'Ultimo aggiornamento: 30 ottobre 2026. Fa fede la versione tedesca.'
};
